import React from 'react';
import Radio from '@material-ui/core/Radio';
import { makeStyles } from '@material-ui/core';

export type RadioProps = import('@material-ui/core/Radio').RadioProps;

const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.grey[700],
  },
}));

const CustomRadio: React.FC<RadioProps> = ({ color, ...rest }) => {
  const classes = useStyles();

  return (
    <Radio className={classes.root} color={color || 'primary'} {...rest} />
  );
};

export default CustomRadio;
